import styled from 'styled-components';
import { visuallyHiddenCss } from '@chegg-ui/theme';
export var NotificationWrapper = styled.span.withConfig({
  componentId: "sc-vrktq-0"
})(["", ""], function (props) {
  return props.className === 'visually-hidden' && "\n   ".concat(visuallyHiddenCss, "\n  ");
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/NotificationBanner/styled.js
// module id = 4579
// module chunks = 11